module.exports = __webpack_public_path__ + "img/selectfile.11dea64c.png";